import type { ChatItem } from '../../../../contracts/harness.types';
import { readToolResultText } from '../../../../contracts/toolResult';
import { parseAgentTodoResult } from './parseAgentTodoResult';
import type { AgentTodoItem } from './types';
import { TODO_TOOL_NAME } from './types';

/**
 * Walk the timeline and build a map of the most recent known state per todo id.
 * Used to forward-fill completed/cancelled statuses on older todo blocks.
 */
export const computeLatestTodoItemsById = (
  items: ChatItem[]
): Map<number, AgentTodoItem> => {
  const latestById = new Map<number, AgentTodoItem>();

  for (const item of items) {
    if (item.kind !== 'tool_use') continue;
    if (item.name !== TODO_TOOL_NAME) continue;
    if (item.status !== 'complete') continue;

    const parsed = parseAgentTodoResult(readToolResultText(item));
    if (!parsed) continue;

    for (const todo of parsed.items) {
      latestById.set(todo.id, todo);
    }
  }

  return latestById;
};
